import SalesContainer from "./containers/SalesContainer";

export default {
  path: "/sales",
  components: { main: SalesContainer, category: null }
};



// WEBPACK FOOTER //
// ./src/routes/Sales/index.js